









































import Vue, { PropType } from 'vue';
import { Column, ESortTypes, ISortTypes } from '@/components/table/types';
import { EAlignTableCell } from '@/types';

export default Vue.extend({
  name: 'TableHeadCell',

  props: {
    column: {
      type: Object as PropType<Column>,
      required: true,
      default: null,
    },
    isSorted: {
      type: Boolean,
      default: false,
    },
    defaultSort: {
      type: String,
      required: false,
      default: 'none',
    },
  },

  watch: {
    isSorted(newValue) {
      if (!newValue) {
        this.sort = ESortTypes.NONE;
        return;
      }
    },
    defaultSort(newValue) {
      this.sort = newValue;
    },
  },

  computed: {
    sortTypes(): ISortTypes {
      return {
        none: ESortTypes.NONE,
        desc: ESortTypes.DESC,
        asc: ESortTypes.ASC,
      };
    },
    alignLeft(): boolean {
      return this.columnAlign === EAlignTableCell.LEFT;
    },
    alignCenter(): boolean {
      return this.columnAlign === EAlignTableCell.CENTER;
    },
    alignRight(): boolean {
      return this.columnAlign === EAlignTableCell.RIGHT;
    },
    alignClasses(): any {
      return {
        'justify-start': this.alignLeft,
        'justify-center': this.alignCenter,
        'justify-end': this.alignRight,
      };
    },
  },

  methods: {
    changeSort() {
      if (!this.column.useSort) return;

      switch (this.sort) {
        case this.sortTypes.none:
          this.sort = ESortTypes.ASC;
          break;

        case this.sortTypes.asc:
          this.sort = ESortTypes.DESC;
          break;

        case this.sortTypes.desc:
          this.sort = ESortTypes.NONE;
          break;
      }

      this.setSortData();
      this.eventChangeSort();
    },
    setSortData() {
      switch (this.sort) {
        case this.sortTypes.none:
          this.sortData = null;
          break;
        case this.sortTypes.asc:
          this.sortData = this.column.field;
          break;
        case this.sortTypes.desc:
          this.sortData = '-' + this.column.field;
      }
    },
    eventChangeSort() {
      this.$emit('changeColumnSort', this.sortData);
    },
  },

  data() {
    return {
      sort: this.defaultSort,
      sortData: null as string | null,
      columnAlign: this.column.align || EAlignTableCell.LEFT,
    };
  },
});
